export default __webpack_public_path__ + "static/media/icon-edit.f900821d.svg";